import "./App.scss";
import Main from "./components/home_page/Main";
import img from "./assets/ShipImage.svg";
import { MdHelp } from "react-icons/md";
import {BsGithub} from "react-icons/bs";
import { Howto } from "./components/home_page/Howto";
import { Error } from "./components/home_page/Error";
import { useState } from "react";
import { Players } from "./Players";
function App() {
  const [width,setwidth]=useState(window.innerWidth);
  window.onresize=()=>{
    if(width<954 && window.innerWidth>=954){
      Players.resetGame();
    }
    setwidth(window.innerWidth);
  };
  console.log(width);
  return (
    (width>=954)?
    <>
      <div className="header">
        <MdHelp size={45} onClick={()=>{
          let ele=document.querySelector(".howto");
          if(ele.classList.contains("none")){
            ele.classList.remove("none");
          }
          else{
            ele.classList.add("none");
          }
        }}/>
        <h1 className="heading">
          BattleShip
          <svg
            width="50"
            height="50"
            viewBox="0 0 462 462"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M153.038 171.806L119.831 182.634V194.184L153.038 184.8V171.806Z"
              fill="#C94747"
            />
            <path
              d="M153.038 184.8L119.831 194.184V207.178L153.038 197.794V184.8Z"
              fill="#3E4347"
            />
            <path
              d="M14.4375 373.209H447.562V447.562H14.4375V373.209Z"
              fill="#75D6FF"
            />
            <path
              d="M218.006 112.613H217.284C218.006 110.447 218.006 108.281 218.006 106.116C218.006 93.8437 209.344 83.0156 197.072 80.85C193.462 66.4125 180.469 55.5844 165.309 55.5844C160.978 55.5844 155.925 56.3063 152.316 58.4719C145.097 47.6438 133.547 41.1469 119.831 41.1469H115.5C108.281 25.2656 92.3999 14.4375 73.6312 14.4375C48.3656 14.4375 28.1531 34.65 28.1531 60.6375C28.1531 86.625 48.3656 106.838 74.3531 106.838C79.4062 106.838 84.4593 106.116 88.7906 104.672C96.0093 114.056 107.559 120.553 119.831 120.553C128.494 120.553 136.434 117.666 142.931 112.613C148.706 118.388 156.647 121.997 165.309 121.997C166.753 121.997 168.197 121.997 169.641 121.275C173.972 128.494 182.634 132.825 191.297 132.825C196.35 132.825 200.681 131.381 205.012 129.216C206.456 134.991 211.509 139.322 218.006 139.322C225.225 139.322 231 133.547 231 126.328C231 118.387 225.225 112.613 218.006 112.613"
              fill="#DAE3EA"
            />
            <path
              d="M243.272 131.381C235.331 127.772 226.669 126.328 218.006 126.328C207.9 126.328 194.184 128.494 185.522 132.825L179.025 184.8H270.703L243.272 131.381"
              fill="#94989B"
            />
            <path
              d="M132.825 197.794L100.341 212.953V250.491H119.831V329.175H290.194V243.994L132.825 197.794Z"
              fill="#62727A"
            />
            <path
              d="M132.825 197.794V237.497H152.316V322.678H322.678V237.497H342.891V197.794H132.825Z"
              fill="#B2C1C0"
            />
            <path
              d="M152.316 342.891L73.6312 355.163V289.472L152.316 250.491V342.891Z"
              fill="#62727A"
            />
            <path
              d="M406.416 410.747C406.416 410.747 184.078 457.669 79.4062 419.409C64.9687 414.356 48.3656 404.972 28.1531 384.038V352.275C28.1531 352.275 102.506 342.891 193.462 293.803C305.353 233.888 403.528 231 435.291 244.716C434.569 243.994 406.416 289.472 406.416 410.747"
              fill="#F15744"
            />
            <path
              d="M407.859 374.653C408.581 347.222 417.244 335.672 428.072 317.625C467.775 254.1 434.569 244.716 434.569 244.716C409.303 286.584 407.859 374.653 407.859 374.653"
              fill="#D33B23"
            />
            <path
              d="M428.072 257.709C387.647 246.159 294.525 254.822 192.019 309.684C102.506 358.05 28.875 361.659 28.1531 361.659V368.156C28.875 368.156 103.95 364.547 194.906 316.181C294.525 262.762 386.925 254.1 425.906 264.206L428.072 257.709"
              fill="white"
            />
            <path
              d="M428.072 258.431C427.35 260.597 426.628 262.762 425.906 264.206C431.681 266.372 441.788 272.147 445.397 282.975C446.841 279.366 447.562 275.756 447.562 272.869C441.787 264.928 433.125 260.597 428.072 258.431Z"
              fill="#B2C1C0"
            />
            <path
              d="M153.037 184.8H322.678V197.794H153.037V184.8Z"
              fill="#62727A"
            />
            <path
              d="M153.037 171.806H322.678V184.8H153.037V171.806Z"
              fill="#FF9D27"
            />
            <path
              d="M132.825 197.794H342.891V236.775H132.825V197.794Z"
              fill="#C5D0D8"
            />
            <path
              d="M146.541 207.9H155.925V227.391H146.541V207.9Z"
              fill="#94989B"
            />
            <path
              d="M171.084 207.9H180.469V227.391H171.084V207.9Z"
              fill="#94989B"
            />
            <path
              d="M195.628 207.9H205.013V227.391H195.628V207.9Z"
              fill="#94989B"
            />
            <path
              d="M220.172 207.9H229.556V227.391H220.172V207.9Z"
              fill="#94989B"
            />
            <path
              d="M245.438 207.9H254.822V227.391H245.438V207.9Z"
              fill="#94989B"
            />
            <path
              d="M269.981 207.9H279.366V227.391H269.981V207.9Z"
              fill="#94989B"
            />
            <path
              d="M294.525 207.9H303.909V227.391H294.525V207.9Z"
              fill="#94989B"
            />
            <path
              d="M319.069 207.9H328.453V227.391H319.069V207.9Z"
              fill="#94989B"
            />
            <path
              d="M165.309 243.994H191.297V256.987H165.309V243.994Z"
              fill="#62727A"
            />
            <path
              d="M309.684 247.603L283.697 254.822V243.994H309.684V247.603Z"
              fill="#62727A"
            />
            <path
              d="M243.994 243.994H269.981V256.987H243.994V243.994Z"
              fill="#62727A"
            />
            <path
              d="M205.012 243.994H231V256.987H205.012V243.994Z"
              fill="#62727A"
            />
            <path
              d="M97.4531 298.856L80.85 306.797V322.678L97.4531 316.181V298.856Z"
              fill="white"
            />
            <path
              d="M145.097 275.034L128.494 283.697V303.909L145.097 297.413V275.034Z"
              fill="white"
            />
            <path
              d="M121.275 287.306L104.672 295.247V313.294L121.275 306.797V287.306Z"
              fill="white"
            />
          </svg>
        </h1>
        <a href="https://github.com/Jayashakthi28/TOP-BattleShip" target="_blank" rel="noreferrer">
        <BsGithub size={45} color={"black"}/>
        </a>
      </div>
      <Howto/>
      <Main />
      <img className="ship-img" src={img} alt="" draggable="false" />
    </>:<Error/>
  );
}

export default App;
